module.exports = __webpack_public_path__ + "img/header_bg.d4ac14e7.png";